import { render, staticRenderFns } from "./TeachersTable.vue?vue&type=template&id=229d9530&scoped=true&"
import script from "./TeachersTable.vue?vue&type=script&lang=js&"
export * from "./TeachersTable.vue?vue&type=script&lang=js&"
import style0 from "./TeachersTable.vue?vue&type=style&index=0&id=229d9530&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229d9530",
  null
  
)

export default component.exports